import React from 'react';
import { observer, inject } from 'mobx-react';
import MaterialTable, { MTableToolbar } from "material-table";
import QarManagerEmployees from './QarManagerEmployees';
import { isValidDate, qarManagersColumns, qarManagersOptions } from '../../helper/constants';
import Grid from "@material-ui/core/Grid";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { Typography, IconButton } from '@material-ui/core';
import { HtmlTooltip } from '../HtmlTooltip/HtmlTooltip';

const QarManager = inject('RootStore')(observer(({ RootStore, ...props }) => {

    const byCommentDate = (a, b) => {
        if (a.creationDate < b.creationDate) {
            return 1;
        }
        if (a.creationDate > b.creationDate) {
            return -1;
        }
        return 0;
    }

    const handleClick = (ev, rowData) => {
        ev.preventDefault();
        RootStore.qarStore.isCommentSectionOpened = true;
        RootStore.qarStore.currentlySelectedManager = rowData;
        RootStore.qarStore.currenlySelectedCommentSection = rowData.soxComments.sort(byCommentDate);
    };

    const handleReviewsHistoryClick = (ev, rowData) => {
        ev.preventDefault();
        RootStore.qarStore.isReviewsHistoryOpened = true;
        RootStore.qarStore.getReviewHistoryByManagerReviewId(rowData.managerReviewID, RootStore.qarStore.currentlySelectedAccountForReview.id);
    }

    return (
        <MaterialTable
            title=""
            data={RootStore.qarStore.managersByAccount}
            columns={[...qarManagersColumns,
            {
                title: "Comments",
                field: "soxComments",
                render: rowData => <>{<button className="btn btn-primary" onClick={(ev) => handleClick(ev, rowData)}>View/Edit ({rowData.soxComments.length})</button>}</>,
                customSort: (a, b) => b.soxComments.length - a.soxComments.length,
                filtering: false
            },
            {
                title: "Review History",
                field: "reviewsHistory",
                render: rowData => <>{<button className="btn btn-primary" onClick={(ev) => handleReviewsHistoryClick(ev, rowData)}>History</button>}</>,
                filtering: false
            }
            ]}
            options={qarManagersOptions}
            detailPanel={[
                {
                    tooltip: 'Show Review',
                    render: rowData => {
                        RootStore.qarStore.currentlySelectedManager = rowData;
                        RootStore.qarStore.employeesByManagerReview = [];
                        return (
                            <QarManagerEmployees />
                        )
                    }
                },
            ]}
            localization={{
                body: { emptyDataSourceMessage: "No records to display, please send emails for this quarter in order to track them" },
                toolbar: {
                    exportCSVName: "Export as XLSX",
                }
            }}
            components={{
                Toolbar: (tableProps) => (
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={3}
                    >
                        <Grid item sm={4}>
                            <h4 style={{ marginLeft: '10px' }}>
                                {props.accountName}
                            </h4>
                        </Grid>
                        <Grid item sm={3} style={{ textAlign: 'right' }}>
                            <h4>{new Date(RootStore.qarStore.creationDate).toUTCString()}</h4>
                            ({new Date(RootStore.qarStore.creationDate).toLocaleString()} local time)
                        </Grid>
                        <HtmlTooltip
                            title={
                                <React.Fragment>
                                    <Typography color="inherit" variant="caption">
                                        This is the compliance review creation date.
                                    </Typography>
                                </React.Fragment>
                            }
                        >
                            <IconButton aria-label="delete" size="small">
                                <HelpOutlineIcon fontSize="inherit" />
                            </IconButton>
                        </HtmlTooltip>
                        <Grid item sm={4} style={{ textAlign: 'left' }}>
                            <MTableToolbar {...tableProps} />
                        </Grid>
                    </Grid>
                )
            }}
        />
    );
}));

export default QarManager;